import { useInfiniteQuery, UseInfiniteQueryOptions, UseInfiniteQueryResult } from '@tanstack/react-query';
import { SnackbarStatus, useSnackbar } from '@weareopenr/component-library';
import { getTimetables, ITimetablesResponseBody } from 'src/api/getTimetables';
import { getBrandId } from 'src/helpers/getBrandId/getBrandId';
import { parseQueryParamsFromRelativeUrlPath } from 'src/helpers';
import { QueryKeys } from '../QueryKeys';

export const useTimetables = (
  limit = 15,
  search?: string,
  rangeIds?: string[],
  options?: UseInfiniteQueryOptions<ITimetablesResponseBody>,
): UseInfiniteQueryResult<ITimetablesResponseBody> => {
  const { showSnackbar } = useSnackbar();

  return useInfiniteQuery({
    queryKey: [QueryKeys.timetables, getBrandId(), search, rangeIds],
    queryFn: async ({ pageParam }) => getTimetables(limit, pageParam, search, rangeIds),
    refetchOnWindowFocus: false,
    onError: () =>
      showSnackbar({ status: SnackbarStatus.ERROR, message: 'Something went wrong whilst fetching timetables' }),
    getNextPageParam: (lastPage) => {
      const nextPageUrlPath = lastPage?.paging?.next;

      if (!nextPageUrlPath) return null;
      return parseQueryParamsFromRelativeUrlPath(nextPageUrlPath).get('after_id');
    },
    ...options,
  });
};
